import React, { useEffect } from "react";
import { useMappedState, useDispatch } from "redux-react-hook";
import { getJobSearchReminders, getTalentSearchReminders } from "./../API";

function HOC(props) {
  const session = useMappedState((state) => state.session);
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchData() {
      const dataResponse = await Promise.all([
        getTalentSearchReminders(session.authToken),
        getJobSearchReminders(session.authToken),
      ]);
      dispatch({ type: "SET_RESUME_REMINDER", payload: dataResponse[0].data.data });
      dispatch({ type: "SET_JOB_REMINDER", payload: dataResponse[1].data.data });
    }
    fetchData();
    // eslint-disable-next-line
  }, []);

  return <props.Component {...props} />;
}

export default HOC;
